import clearAndReadableLayouts from '@/assets/img/users-cases/clear-and-readable-layouts.webp';
import clearAndReadableLayoutsHow from '@/assets/img/users-cases/clear-and-readable-layouts-how.webp';
import clearAndReadableLayoutsResult from '@/assets/img/users-cases/clear-and-readable-layouts-result.webp';

export default {
  slug: 'clear-and-readable-layouts',
  order: 27,
  title: '2D Floor Plan',
  subtitle: 'Fast creation of clear and readable 2D layouts for property listings using AI software.',
  tags: ['FloorPlanAI', 'RealEstateTools'],

  images: {
    hero: clearAndReadableLayouts,
    aboutTop: clearAndReadableLayoutsHow,
    aboutBottom: clearAndReadableLayoutsResult,
  },

  howText:
    'Agents uploaded sketches and property layouts to the 2D floor plan AI, which corrected dimensions and produced professional 2D floorplans. The same files were used to generate 3D floor plan renderings and a 360° virtual tour, ensuring consistent visual presentation for online listings.',

  resultText:
    'With the 2D floor plan creator workflow, the agency quickly produced professional 2D layouts while simultaneously generating 3D floor plan renderings and 360° virtual walkthroughs. This streamlined the listing process, improved buyer comprehension of room layouts, and enhanced the visual appeal of properties across online platforms.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
